module.exports = __webpack_public_path__ + "static/media/gummy-red.4b48e9ef.png";